var _circle, _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#5bbc65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.67 11.42c0-2.99-2.99-5.42-6.68-5.42s-6.68 2.43-6.68 5.42c0 2.68 2.37 4.92 5.58 5.34.22.05.51.14.59.33.07.17.04.43.02.6 0 0-.08.47-.1.57-.03.17-.13.66.58.36s3.84-2.26 5.25-3.88c.97-1.06 1.43-2.14 1.43-3.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5bbc65",
    d: "M16.45 13.14c.07 0 .13-.06.13-.13v-.47c0-.07-.06-.13-.13-.13h-1.27v-.49h1.27c.07 0 .13-.06.13-.13v-.47c0-.07-.06-.13-.13-.13h-1.27v-.49h1.27c.07 0 .13-.06.13-.13v-.47c0-.07-.06-.13-.13-.13h-1.88c-.07 0-.13.06-.13.13v2.91c0 .07.06.13.13.13zM9.51 13.14c.07 0 .13-.06.13-.13v-.47c0-.07-.06-.13-.13-.13H8.24V10.1c0-.07-.06-.13-.13-.13h-.47c-.07 0-.13.06-.13.13v2.91c0 .07.06.13.13.13h1.88Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.73,
    height: 3.17,
    x: 10.04,
    y: 9.97,
    fill: "#5bbc65",
    rx: 0.13,
    ry: 0.13
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5bbc65",
    d: "M13.86 9.97h-.47c-.07 0-.13.06-.13.13v1.73l-1.33-1.8-.01-.01h-.47c-.07 0-.13.06-.13.13v2.91c0 .07.06.13.13.13h.47c.07 0 .13-.06.13-.13v-1.73l1.33 1.8.03.03h.5c.07 0 .13-.06.13-.13v-2.91c0-.07-.06-.13-.13-.13Z"
  })));
};
export default SvgLine;